import {
    Button,
    Grid,
    Typography,
    AppBar,
    IconButton,
    Toolbar,
    Box,
    Paper
} from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { Menu as MenuIcon } from '@mui/icons-material';
import { Logout as LogoutIcon } from '@mui/icons-material';
import { Person as PersonIcon } from '@mui/icons-material';
import { globalProps } from 'src/config';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ROUTEHOME } from '../../routes';
import { OAuthToken } from '../../types';
import { AppState } from 'src/store';
import { User } from 'src/auth';
import LandingCard from '../components/LandingCard';
import Header from '../components/Header';
import { changePageTitle } from '../../actions';

import {
    changePage,
    doLogout
} from '../../actions'

import * as routes from '../../routes'

const UserName: React.FC<{ user: User }> = ({ user }) => {
    const { username } = user;
    const isRoot = user.root;

    return <>
        <IconButton color="inherit"><PersonIcon fontSize='small' /></IconButton>
        <Box sx={{ lineHeight: '2em', mr: 1 }}>
            {isRoot && <Typography variant="button"><i>{username}</i></Typography>}
            {!isRoot && <Typography variant="button">{username}</Typography>}
        </Box>
    </>
}

const Landing: React.FC = () => {
    const dispatch = useDispatch();
    const loginState = useSelector((state: AppState) => state.global.login);
    const globalViewOpts = useSelector((state: AppState) => state.global.view);

    useEffect(() => {
        if (loginState.token !== null) {
            dispatch(changePage(routes.ROUTEUI));
        }
    }, [loginState.token]);

    useEffect(() => {
        dispatch(changePageTitle(''))
    }, []);

    return (<>
        <Header />
        <Grid
            container
            spacing={0}
            direction="column"
            // alignItems="center"
            // justifyContent="center"
            sx={{ minHeight: '100vh', backgroundColor: theme => theme.palette.grey[300] }}
        >
            <Grid
                container
                spacing={1}
                direction="column"

                sx={{
                    minHeight: '100vh',
                    backgroundColor: theme => theme.palette.grey[300],
                    maxWidth: 1000, mr: 'auto', ml: 'auto',
                    borderColor: theme => theme.palette.grey[400],
                    borderWidth: 1,
                    borderStyle: 'solid',
                    borderTopWidth: 0,
                    borderBottomWidth: 0,
                    pt: 10,
                }}
            >
                <LandingCard
                    title={'No code'}
                    text={`Create your own data model and launch the service in minutes, no coding skills required.
                        Use our intuitive user-friendly interface to create an application, define resources you need and
                        link them via relationships. Hit the 'Launch' button and start using your application right away.
                        You will have access to the admin console, where you can control every aspect of the application and
                        manage the resources you defined.`}
                    src={process.env.PUBLIC_URL + '/code.png'}
                />
                <LandingCard
                    mirror
                    title={'Open API support'}
                    text={`Enjoy full Open API specification support - after the application is launched, you
                        can write own requests and try them out right away or download and share the openapi.json
                        documentation for your service to collaborate with others or use it as a part of microservices infrastructure.`}
                    src={process.env.PUBLIC_URL + '/openapi.png'}
                />
                <LandingCard
                    title={'Fine grained access control'}
                    text={`The service offers comprehensive system of roles that you can assign to users in order
                        to control the access to resources.`}
                >
                    <VerifiedUserIcon
                        sx={{
                            width: '80%',
                            height: '80%',
                            m: 'auto',
                            color: theme => theme.palette.primary.main,
                        }}
                    />
                </LandingCard>
                <LandingCard
                    mirror
                    title={'Intuitive user-friendly filtering'}
                    text={`An advanced filtering UI allows you to define complex criteria to request precise slices
                        of data. Save your searches to create your own views of data.`}
                    src={process.env.PUBLIC_URL + '/filtering.png'}
                />
                <LandingCard
                    title={'Data visualization'}
                    text={`Visualize the data structure as you browse the resources.`}
                    src={process.env.PUBLIC_URL + '/visualize.png'}
                />
                <Grid size={10}><Typography sx={{ p: 2 }} variant={'body2'} textAlign={'center'}>All rights reserved (c) RestApiCms LLC</Typography></Grid>
            </Grid>
        </Grid>
    </>)
}

export default Landing
